module.exports = __webpack_public_path__ + "static/media/img-clock-large@2x.37d91e44.png";